import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { EncodingUtils } from "../../../../shared/utils/encoding.utils";
import { TOKEN } from "../auth/token";

@Component({
  selector: "app-external-redirect",
  template: `
    <div class="d-flex flex-column align-items-center mt-5">
      <div class="spinner-border mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  `,
})
export class ExternalRedirectComponent implements OnInit, OnDestroy {
  private _routeParamsSubscription: Subscription = new Subscription();

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this._routeParamsSubscription = this.route.queryParams.subscribe(
      async (params) => {
        let token = params.token ?? "";

        if (token != "" && typeof Storage !== "undefined") {
          localStorage.setItem(TOKEN, EncodingUtils.encodeBase64(token));

          this.router.navigateByUrl("/login");
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this._routeParamsSubscription) {
      this._routeParamsSubscription.unsubscribe();
    }
  }
}
